import APIRequestHelper from '../helpers/api-request-helper';
import { SercomTypes } from '../support/sercom-types';

const AdminService = {
  async getCompaniesDatasource(accountType = 'clients') {
    return APIRequestHelper.getDataManager('POST', `admin/companies?accountType=${accountType}`);
  },
  async getNotificationStatisticsDatasource() {
    return APIRequestHelper.getDataManager('POST', 'admin/notification_statistics');
  },
  async getLeadsDatasource() {
    return APIRequestHelper.getDataManager('POST', 'admin/leads');
  },
  async createAccount(account: SercomTypes.Account) {
    const payload = {
      firstName: account.firstName,
      lastName: account.lastName,
      email: account.email,
      password: account.password,
      companyName: account.companyName,
      subscriptionPlan: account.subscriptionPlan,
      subscriptionFrequency: account.subscriptionFrequency,
      language: account.language,
      expirationDate: account.expirationDate,
      maxMembers: account.maxMembers,
      affiliateId: account.affiliateId,
    };
    return await APIRequestHelper.sendRequest('POST', 'admin/create_account', false, payload);
  },

  async closeCompany(companyId: string) {
    return APIRequestHelper.sendRequest('POST', `admin/close_company?companyId=${companyId}`, false);
  },
  async getSubscription(companyId: string) {
    return await APIRequestHelper.sendRequest('GET', `admin/get_subscription/${companyId}`, false, null);
  },
  async getKpis() {
    return await APIRequestHelper.sendRequest('GET', 'admin/get_admin_kpis', false, null);
  },
  async getDailyKpis() {
    return await APIRequestHelper.sendRequest('GET', 'admin/kpis/daily?days=30', false, null);
  },
  async getCompanyTimers(companyId: string) {
    return await APIRequestHelper.sendRequest('GET', `admin/companies/${companyId}/timers`, false, null);
  },
  async deleteCompanyTimer(timerId: string) {
    return await APIRequestHelper.sendDeleteRequest(`admin/timers/${timerId}`);
  },
  async getQuickBooksLinks(companyId: string) {
    return await APIRequestHelper.sendRequest('GET', `admin/quickbooks_links/${companyId}`, false, null);
  },
  async clearQuickBooksLinks(companyId: string, clearItems: boolean, clearTaxes: boolean, clearClients: boolean) {
    return await APIRequestHelper.sendRequest('POST', 'admin/clear_quickbooks_links', false, {
      companyId,
      clearItems,
      clearTaxes,
      clearClients,
    });
  },
  async updateSubscription(subscription: SercomTypes.Subscription) {
    const payload = {
      companyId: subscription.companyId,
      plan: subscription.plan,
      frequency: subscription.frequency,
      maxMembersCount: subscription.maxMembersCount,
      expirationDate: subscription.expirationDate,
      isTrial: subscription.isTrial,
      optimizer: subscription.optimizer,
      timesheet: subscription.timesheet,
      timesheetApproval: subscription.timesheetApproval,
      purchaseOrder: subscription.purchaseOrder,
      communication: subscription.communication,
      payment: subscription.payment,
      lumen: subscription.lumen,
      board: subscription.board,
      recurringJob: subscription.recurringJob,
      publicApi: subscription.publicApi,
      securityRole: subscription.securityRole,
      affiliateId: subscription.affiliateId,
    };
    return await APIRequestHelper.sendRequest('POST', 'admin/update_subscription', false, payload);
  },
};
export default AdminService;
